module.exports = __webpack_public_path__ + "img/mgh-nagoya-sp@2x.0c1a02d1.jpg";